import React, {useEffect, useRef} from "react";

import styles from "./HardwareSection.module.scss";
import Image from "./Global/Image";

import src from "../images/hardware.jpg";
import srcRet from "../images/hardware@2x.jpg";
import webp from "../images/hardware.webp";
import webpRet from "../images/hardware@2x.webp";
import mobile from "../images/mobile/hardware.jpg";

import playerSrc from "../images/player-01.jpg";
import playerSrcRet from "../images/player-01@2x.jpg";
import playerWebp from "../images/player-01.webp";
import playerWebpRet from "../images/player-01@2x.webp";

import webcam from "../images/illustrations/webcam.svg";
import headphones from "../images/illustrations/headphones.svg";
import controller from "../images/illustrations/controller.svg";
import crown from "../images/illustrations/crown.svg";
import keyboard from "../images/illustrations/keyboard.svg";
import controllers from "../images/controllers.svg";

import gsap, {TimelineMax} from 'gsap';
import ScrollMagic from "scrollmagic";
import ImageText from "../components/Elements/ImageText";
import Chart from "./Chart";
import Chart2 from "./Chart2";
import TitleBloc from "./Elements/TitleBloc";


export default function HardwareSection() {
    const parent = useRef(null)

    useEffect(() => {
        const elements = parent.current.querySelectorAll('[data-scroll-animation]');
        const controller = new ScrollMagic.Controller({
            refreshIntervals: 0
        });

        Object.values(elements).map(item => {
            new ScrollMagic.Scene({
                triggerHook: 'onEnter', triggerElement: parent.current, duration: '100%', reverse: true
            })
                .setTween(
                    new TimelineMax().to(item, .3, {
                        rotate: -180
                    }, 'start'))
                .addTo(controller);
        });

        let y = 0;

        window.addEventListener('scroll', (e) => {

        });
    }, [])

    return (
        <>
            <section className={styles.Main} ref={parent}>

                <div className={styles.Background}>
                    <img src={webcam} data-scroll-animation/>
                    <img src={crown} data-scroll-animation/>
                    <img src={controller} data-scroll-animation/>
                    <img src={headphones} data-scroll-animation/>
                    <img src={keyboard} data-scroll-animation/>
                </div>

                <div className="container">
                    <p className={styles.Text}>
                        Aidé par la crise sanitaire qui a contraint des milliards de personnes à rester chez soi avec
                        les périodes de confinement mises en place pour tenter d’enrayer la pandémie de Covid-19, ainsi
                        que par l’essor des jeux mobiles, <strong>
                        <a href={"https://www.etoro.com/fr/copyportfolios/inthegame/stats"} rel={'dofollow'} target={'_blank'}>le marché des jeux vidéo</a> est plus que jamais global, et les enjeux sont à la dimension du marché
                        : technologiques, financiers, sociaux et politiques…
                    </strong>
                    </p>

                </div>

                <TitleBloc image={{src, srcRet, webp, webpRet, mobile}} number={1}>
                    <h2>
                        Hardware / Software
                        et plateformes
                    </h2>

                    <p>
                        Le secteur du jeu vidéo fait partie des industries du divertissement ayant une croissance la
                        plus rapide du monde. Ce dynamisme repose notamment sur une certaine complémentarité, qui
                        distingue d’ailleurs le secteur des autres industries culturelles et qui en fait toute sa
                        spécificité. Il est en effet porté à la fois par les ventes
                        du <strong>Hardware</strong> (matériel, consoles, PC Gaming…) et celles
                        du <strong>Software</strong> (logiciel).
                    </p>

                </TitleBloc>
            </section>

            <section className={styles.Content}>
                <div className="container">
                    <ImageText image={{src: controllers}}>
                        <p>
                            Le cabinet Accenture chiffre à 200 milliards de dollars les ventes directes de consoles, de jeux vidéo et d’abonnements, mais aussi des achats inclus dans les jeux, et des revenus publicitaires mobiles. A cela s'ajoutent 100 milliards de dollars de revenus indirects provenant des industries adjacentes telles que les appareils mobiles, les PC « gamer », les périphériques et les communautés liées aux jeux vidéo. A lui seul, l’eSport, qui connait un succès fulgurant, pèse 1,3 milliard de dollars. Il faut aussi noter que, ces dernières années, les plateformes et les jeux sur mobile sont devenus de véritables piliers de l'industrie…                        </p>
                    </ImageText>

                    <div className={styles.Graphs}>
                        <p className={'head-text'}>
                            Revenus <strong>directs et indirects</strong> <br/> dans l’industrie du jeu vidéo
                        </p>

                        <div className={styles.GraphsWrapper}>
                            <div className={styles.GraphsItem}>
                                <Chart/>

                                <p>
                                    Revenus indirects <br/>
                                    <span>
                                        100 Milliards $
                                    </span>
                                </p>
                            </div>

                            <div className={styles.GraphsItem}>
                                <Chart2/>

                                <p>
                                    Revenus directs <br/>
                                    <span>$200 Milliards $</span> <small>(+21,3%)</small>
                                </p>
                            </div>
                        </div>
                    </div>

                    <ImageText image={{
                        src: playerSrc,
                        srcRet: playerSrcRet,
                        webp: playerWebp,
                        webpRet: playerWebpRet
                    }}>
                        <p>
                            La rentabilité du secteur semble d’ailleurs avoir attiré de nombreuses grandes entreprises, telles qu’Apple, Google, Amazon, Disney ou encore Netflix. En effet, Apple a déjà mis un pied dedans avec son service de gaming par abonnement, Apple Arcade. Celui de Google, le « Play Pass », a été lancé à l’automne 2019. Un peu plus discret, Facebook n'en est pas moins bien présent dans le secteur, en proposant notamment aux amateurs de jeux vidéo de regarder, en direct, des parties d'autres « gamers », à l'instar de ce que propose Twitch. Dernièrement, le géant américain du streaming vidéo Netflix s'est offert le développeur et éditeur indépendant californien de jeux vidéo Night School Studio, dans le cadre de sa diversification sur ce nouveau marché.
                        </p>
                    </ImageText>
                </div>
            </section>
        </>
    )
}
